import React from "react";
import { Button } from "./ui/button";

const VideoHeroSection = () => {

  return (
    <section className="relative h-[50vh] md:h-[70vh] min-h-[400px] md:min-h-[500px] overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0">
        <video
          id="hero-video"
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          poster="https://customer-assets.emergentagent.com/job_festpreis-maler/artifacts/lyihsrh4_Guide%20To%20Exterior%20Spray%20Painting%20_%20Family%20Handyman.jpeg"
        >
          {/* Airless spray gun background */}
          <div 
            className="w-full h-full bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://customer-assets.emergentagent.com/job_festpreis-maler/artifacts/lyihsrh4_Guide%20To%20Exterior%20Spray%20Painting%20_%20Family%20Handyman.jpeg')`
            }}
          ></div>
        </video>
      </div>

      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-20 h-20 bg-gradient-to-br from-cyan-400 to-purple-500 rounded-full animate-pulse"></div>
        <div className="absolute top-32 right-20 w-16 h-16 bg-gradient-to-br from-green-400 to-blue-500 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
        <div className="absolute bottom-20 left-1/3 w-12 h-12 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full animate-pulse" style={{animationDelay: '2s'}}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Left Content */}
            <div className="text-white">
              <div className="mb-6">
                <h2 className="text-4xl lg:text-6xl font-bold mb-4 drop-shadow-2xl">
                  <span className="text-cyan-400">Wir</span>{" "}
                  <span className="text-white">streichen</span>{" "}
                  <span className="text-orange-400">Ihre</span>{" "}
                  <span className="text-purple-400">Wohnung!</span>
                </h2>
                <p className="text-xl lg:text-2xl text-gray-200 mb-6 drop-shadow-lg">
                  Airless-Technik: Schnell, professionell, sauber
                </p>
                <p className="text-lg text-gray-300 leading-relaxed drop-shadow-md">
                  Moderne Spritzpistolen für perfekte Ergebnisse. Unsere Profi-Ausrüstung 
                  kombiniert mit erstklassigen Farben garantiert streifenfreie Oberflächen.
                </p>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <a 
                  href="https://wa.me/4915758183212?text=Hallo,%20ich%20interessiere%20mich%20für%20ein%20kostenloses%20Angebot%20für%20Malerarbeiten."
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button 
                    size="lg" 
                    className="bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500 hover:from-cyan-600 hover:via-purple-600 hover:to-pink-600 text-white font-bold text-lg px-8 py-4 rounded-xl shadow-2xl hover:shadow-cyan-500/25 transition-all duration-300 transform hover:scale-105 border border-cyan-300/20 w-full sm:w-auto"
                  >
                    💬 Jetzt Angebot erhalten
                  </Button>
                </a>
                
                <a 
                  href="https://www.instagram.com/floriamalerfestpreis/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button 
                    size="lg"
                    variant="outline"
                    className="border-2 border-pink-400 text-pink-400 hover:bg-pink-400 hover:text-white font-bold text-lg px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 backdrop-blur-sm bg-black/20 w-full sm:w-auto"
                  >
                    📷 Instagram ansehen
                  </Button>
                </a>
              </div>

              {/* Video Stats */}
              <div className="grid grid-cols-3 gap-6 text-center">
                <div className="bg-black/30 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/20">
                  <div className="text-2xl font-bold text-cyan-400 drop-shadow-lg">BW</div>
                  <div className="text-sm text-gray-300">Einsatzgebiet</div>
                </div>
                <div className="bg-black/30 backdrop-blur-sm rounded-xl p-4 border border-purple-500/20">
                  <div className="text-2xl font-bold text-purple-400 drop-shadow-lg">Airless</div>
                  <div className="text-sm text-gray-300">Technik</div>
                </div>
                <div className="bg-black/30 backdrop-blur-sm rounded-xl p-4 border border-orange-500/20">
                  <div className="text-2xl font-bold text-orange-400 drop-shadow-lg">Festpreis</div>
                  <div className="text-sm text-gray-300">Garantie</div>
                </div>
              </div>
            </div>

            {/* Right Content - Professional Work Showcase */}
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                {/* Professional Work Frame */}
                <div className="w-80 h-80 bg-gradient-to-br from-cyan-500/30 to-purple-500/30 rounded-3xl flex items-center justify-center backdrop-blur-md border-2 border-cyan-400/30 shadow-2xl">
                  <div className="w-64 h-64 bg-black/40 rounded-2xl flex items-center justify-center relative overflow-hidden border border-white/20">
                    
                    {/* Profitec Product Showcase */}
                    <div className="w-full h-full bg-gradient-to-br from-white to-gray-100 rounded-2xl flex items-center justify-center p-6">
                      {/* Product Container */}
                      <div className="text-center">
                        {/* Profitec Rekord Pro Product Image */}
                        <img 
                          src="https://customer-assets.emergentagent.com/job_festpreis-maler/artifacts/h2xgi5qw_p116-rekord-pro.webp"
                          alt="Profitec Rekord Pro P116 Ultramatte Innenfarbe"
                          className="w-32 h-40 mx-auto mb-4 rounded-xl shadow-lg object-contain bg-white p-2 border-2 border-yellow-200"
                        />
                        
                        {/* Product Info */}
                        <div className="text-gray-800">
                          <div className="text-lg font-bold mb-1">PROFITEC</div>
                          <div className="text-sm font-semibold text-blue-600">REKORD PRO P116</div>
                        </div>
                      </div>
                    </div>

                    {/* Product Badge */}
                    <div className="absolute top-4 right-4 bg-gradient-to-r from-yellow-500 to-orange-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                      🤝 Partner
                    </div>
                  </div>
                </div>

                {/* Floating Elements */}
                <div className="absolute -top-4 -right-4 w-8 h-8 bg-gradient-to-br from-pink-400 to-red-500 rounded-full animate-bounce"></div>
                <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-gradient-to-br from-green-400 to-blue-500 rounded-full animate-bounce" style={{animationDelay: '1s'}}></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 w-full h-32 bg-gradient-to-t from-gray-900 to-transparent"></div>
    </section>
  );
};

export default VideoHeroSection;